import { useEffect } from "react"

function onPopState(e: PopStateEvent): void {
    e.preventDefault()
    history.go(1)
}

function beforeUnload(e: BeforeUnloadEvent): string | null {
    e.preventDefault()
    // This is for Chrome https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
    e.returnValue = ""
    return null
}

// NOTE: window.addEventListener is idempotent
// See docs: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
export const usePreventNavigationAndRefresh = (enabled: boolean) => {
    usePreventNavigation(enabled)
    usePreventRefresh(enabled)
}

export const usePreventRefresh = (enabled: boolean) => {
    useEffect(() => {
        if (!window || !enabled) return

        window.addEventListener("beforeunload", beforeUnload)

        return () => {
            window.removeEventListener("beforeunload", beforeUnload)
        }
    }, [enabled])
}

export const usePreventNavigation = (enabled = true) => {
    useEffect(() => {
        if (!window || !enabled) return

        history.pushState(null, "", location.href)
        window.addEventListener("popstate", onPopState)

        return () => {
            window.removeEventListener("popstate", onPopState)
        }
    }, [enabled])
}
